import React from "react";
import { Route, Routes } from "react-router-dom";
import Order from "./app/order";
import Inventory from "./app/inventory";
import DashBoard from "./app/dashBoard";
import Users from "./app/users";
import Settings from "./app/settings";
import AdvSettings from "./app/advSettings";
import Print from "./app/print";
import Fulfilled from "./app/fulfilled";
import PendingOrder from "./app/pendingOrder";
import ShippingPrice from "./app/shippingprice";
import ImportantOrder from "./app/importantOrder";
import Leads from "./app/leads";
import Role from "./app/role";
import ViewUserRole from "./app/role/ViewUserRole";
import ViewOrder from "./app/viewOrder";
import AddOrder from "./app/order/AddOrder";
import Product from "./app/product";
import ProductCategory from "./app/inventory/ProductCategory";
import UpdateProductType from "./app/inventory/UpdateProductType";
import Analytics from "./app/analytics";
import LoginPage from "./app/auth/login";
import Enquiry from "./app/enquiryComponent";
import AddEnquiry from "./app/enquiryComponent/AddEnquiry";
import ViewEnquiry from "./app/viewEnquiry";
import Profile from "./app/profile";
import AccessDenied from "./components/AccessDenied";
import Notifications from "./components/Notifications";
import AusPost from "./app/auspost";
import AusPostLabel from "./app/auspostlabel";
import AusPostGenerateOrder from "./app/auspostgeneratedorder";
import Logs from "./app/logs";
import LogsByOrderDetails from "./app/logs/LogsByOrderDetails";
import { ProtectedRoute } from "./ProtectedRoute";
import { EmailRestrictedRoute } from "./EmailRestrictedRoute";
import ManifestByMonth from "./app/auspostmonthlyorder";
import Customer from "./app/customers";
import ViewCustomer from "./app/customers/ViewCustomer";
import Pods from "./app/pod";
import FacebookLeads from "./app/facebookLeads";
import Transaction from "./app/transaction";
import Campaign from "./app/campaign";

const AppRoutes = () => {
  const roleid = parseInt(localStorage.getItem("auth_role"));
  console.log(typeof roleid);

  return (
    <Routes>
      <Route path="/" element={<DashBoard />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/pending-order/:pending"
        element={
          <ProtectedRoute roles="pending-order">
            <PendingOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/:order"
        element={
          <ProtectedRoute roles="orders">
            <Order />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-order"
        element={
          <ProtectedRoute roles="orders">
            <AddOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/transactions"
        element={
          <EmailRestrictedRoute
            allowedEmails={[
              "ankit@logicsofts.com",
              "suny@logicsofts.com",
              "ekta@printyo.net.au",
            ]}
          >
            <Transaction />
          </EmailRestrictedRoute>
        }
      />
      <Route
        path="/campaign"
        element={
          <EmailRestrictedRoute
            allowedEmails={[
              "ankit@logicsofts.com",
              "suny@logicsofts.com",
              "ekta@printyo.net.au",
            ]}
          >
            <Campaign />
          </EmailRestrictedRoute>
        }
      />
      <Route path="/product/:product" element={<Product />} />
      <Route
        path="/analytics"
        element={
          <EmailRestrictedRoute>
            <Analytics />
          </EmailRestrictedRoute>
        }
      />
      <Route
        path="/shipping-price/:pricepage"
        element={
          <ProtectedRoute roles="orders">
            <ShippingPrice />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enquiry/:enquiry"
        element={
          <ProtectedRoute roles="enquiry">
            <Enquiry />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enquiry/:orderId/details"
        element={
          <ProtectedRoute roles="enquiry">
            <ViewEnquiry />
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-enquiry"
        element={
          <ProtectedRoute roles="enquiry">
            <AddEnquiry />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/:orderId/details"
        element={
          <ProtectedRoute roles="orders">
            <ViewOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pending-order/:orderId/details"
        element={
          <ProtectedRoute roles="pending-order">
            <ViewOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/important-order/:important"
        element={
          <ProtectedRoute roles="important-order">
            <ImportantOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/important-order/:orderId/details"
        element={
          <ProtectedRoute roles="important-order">
            <ViewOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfilled/:fulfilled/details"
        element={
          <ProtectedRoute roles="fulfilled">
            <ViewOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/print/:orderId/details/:print"
        element={
          <ProtectedRoute roles="print">
            <ViewOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/leads"
        element={
          <ProtectedRoute roles="leads">
            <Leads />
          </ProtectedRoute>
        }
      />
      <Route
        path="/print/:print"
        element={
          <ProtectedRoute roles="print">
            <Print />
          </ProtectedRoute>
        }
      />
      <Route
        path="/fulfilled/:fulfilled"
        element={
          <ProtectedRoute roles="fulfilled">
            <Fulfilled />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/:inventory"
        element={
          <ProtectedRoute roles="inventory">
            <Inventory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/:producttypeId/details/:producttypePageId"
        element={
          <ProtectedRoute roles="inventory">
            <ProductCategory />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory/:producttypeId/update-producttype"
        element={
          <ProtectedRoute roles="inventory">
            <UpdateProductType />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedRoute roles="notifications">
            <Notifications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pods"
        element={
          <ProtectedRoute roles="print">
            <Pods />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customers"
        element={
          <ProtectedRoute roles="print">
            <Customer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customers/:customerId/details"
        element={
          <ProtectedRoute roles="print">
            <ViewCustomer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/facebook-leads"
        element={
          <ProtectedRoute roles="facebook-leads">
            <FacebookLeads />
          </ProtectedRoute>
        }
      />
      <Route path="/profile" element={<Profile />} />
      <Route
        path="/settings"
        element={
          <ProtectedRoute roles="settings">
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/advanced-settings"
        element={
          <ProtectedRoute roles="advanced-settings">
            <AdvSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute roles="users">
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path="/auspost"
        element={
          <ProtectedRoute roles="users">
            <AusPost />
          </ProtectedRoute>
        }
      />
      <Route
        path="/auspost-label"
        element={
          <ProtectedRoute roles="users">
            <AusPostLabel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/generatedorder-auspost"
        element={
          <ProtectedRoute roles="users">
            <AusPostGenerateOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/monthly-manifest"
        element={
          <ProtectedRoute roles="user-roles">
            <ManifestByMonth />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-roles"
        element={
          <ProtectedRoute roles="user-roles">
            <Role />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-roles/:userrolesId/details"
        element={
          <ProtectedRoute roles="user-roles">
            <ViewUserRole />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs/:log"
        element={
          <ProtectedRoute roles="user-roles">
            <Logs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs/details/:orderid"
        element={
          <ProtectedRoute roles="user-roles">
            <LogsByOrderDetails />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<AccessDenied />} />
    </Routes>
  );
};

export default AppRoutes;
